/**
 * LaunchCountdown — live tick-down to June 22, 2026 beta close.
 * Mounted at the top of the Dashboard so every athlete sees the urgency.
 */
import { useState, useEffect } from 'react';

const TARGET = new Date('2026-06-22T00:00:00').getTime();

const calculateTimeLeft = () => {
  const difference = TARGET - Date.now();
  if (difference <= 0) return {};
  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / 1000 / 60) % 60),
    seconds: Math.floor((difference / 1000) % 60),
  };
};

export default function LaunchCountdown() {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!timeLeft.days && !timeLeft.hours && !timeLeft.minutes) {
    // Beta closed — launch is live. Nothing to show on dashboard.
    return null;
  }

  return (
    <div
      className="bg-gradient-to-r from-neutral-900 to-neutral-950 border border-neutral-800 rounded-xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-lg"
      data-testid="launch-countdown"
    >
      <div>
        <h4 className="font-bold text-white text-base">The Final Push 🏀</h4>
        <p className="text-xs text-neutral-400">
          Beta locks down soon. Drop your feedback before we go live.
        </p>
      </div>
      <div className="flex gap-3 text-center" data-testid="countdown-units">
        {[
          { label: 'D', value: timeLeft.days, key: 'days' },
          { label: 'H', value: timeLeft.hours, key: 'hours' },
          { label: 'M', value: timeLeft.minutes, key: 'minutes' },
          { label: 'S', value: timeLeft.seconds, key: 'seconds' },
        ].map((unit) => (
          <div
            key={unit.key}
            className="bg-neutral-900 border border-neutral-800 px-3 py-2 rounded-lg min-w-[50px]"
            data-testid={`countdown-${unit.key}`}
          >
            <div className="font-mono text-lg font-bold text-white">
              {String(unit.value).padStart(2, '0')}
            </div>
            <div className="text-[10px] text-neutral-500 font-bold uppercase">
              {unit.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
